export default __webpack_public_path__ + "static/media/Priest's Gloves of the Underworld.e0b20672.jpg";